import { render } from "./ChatView.vue?vue&type=template&id=48b9a7d5&scoped=true"
import script from "./ChatView.vue?vue&type=script&lang=js"
export * from "./ChatView.vue?vue&type=script&lang=js"

import "./ChatView.vue?vue&type=style&index=0&id=48b9a7d5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b9a7d5"]])

export default __exports__